import { useQuery } from "@tanstack/react-query";
import axios from "../api/axios";
import { BenefitInfo } from "../components/card/BenefitBadgeCard";

interface CheckoutInfo {
    doctor: {
        name: string;
        specialization: string;
        photoUrl: string;
        price_chat: number;
        price_video: number;
    };
    transaction_fee: number;
    voucher: {
        id: number;
        code: string;
        discount_value: number;
    } | null
    gross: number;
    discount: number;
    total: number;
    benefit?: BenefitInfo;
    payment_window_minutes?: number;
}

export const useCheckout = ({
    authToken,
    practitionerRoleId,
    isAuto,
    selectedVoucher,
    selectedPayment,
    }: any) => {
    return useQuery<CheckoutInfo>({
        queryKey: [
        "checkout-info",
        practitionerRoleId,
        selectedVoucher?.id,
        selectedPayment?.id,
        ],
        queryFn: async () => {
        const payload: any = {
            doctor_assign_status: isAuto ? "unassigned" : "assigned",
            voucher_id: selectedVoucher?.id || null,
            payment_method: selectedPayment,
        };

        if (!isAuto) {
            payload.practitioner_role_id = practitionerRoleId;
        }

        const res = await axios.post("/teleconsult/checkout-info", payload, {
            headers: { Authorization: `Bearer ${authToken}` },
        });

        return res.data;
        },
        enabled: !!authToken,
        staleTime: 0,
        retry: 1,
        refetchOnMount: true,
        refetchOnWindowFocus: false
    });
};